import React, { Fragment, useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import { title } from '../../utils';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

import logo from '../../assets/images/logo.png';
import logoWhite from '../../assets/images/logo-image-white.png';

import { userActions } from '../../actions';
import { connect } from 'react-redux';

function LoginPage({ loginUser, error, disabledError, user }) {
  const [username, setUsername] = useState('');
  const [pwd, setPwd] = useState('');
  const navigate = useNavigate();

  // Navigate to home when login is successful
  useEffect(() => {
    if (user && user.id) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleInputChange = e => {
    const { name, value } = e.target;
    if (name === 'username') {
      setUsername(value);
    } else if (name === 'pwd') {
      setPwd(value);
    }
  };

  const handleLogin = e => {
    e.preventDefault();
    loginUser(username, pwd);
  };

  return (
    <Fragment>
      <Helmet>{title('Connexion')}</Helmet>

      <div className="login-page">
        <div className="left-block">
          <form className="login-form">
            <header>
              <h1>Connexion</h1>
            </header>

            <div>
              <p>
                <label htmlFor="username">Courriel :</label>
                <input
                  type="text"
                  name="username"
                  id="username"
                  value={username}
                  onChange={handleInputChange}
                />
              </p>

              <p>
                <label htmlFor="pwd">Mot de passe :</label>
                <input
                  type="password"
                  name="pwd"
                  id="pwd"
                  value={pwd}
                  onChange={handleInputChange}
                />
              </p>

              {error && (
                <b className="error">
                  {disabledError
                    ? 'Ce compte est présentement désactivé'
                    : 'Courriel ou mot de passe invalide'}
                </b>
              )}

              <div className="buttons">
                <button
                  type="button"
                  className="button ghost slim"
                  onClick={() => navigate('/password/ask')}
                >
                  Mot de passe oublié ?
                </button>
                <button onClick={handleLogin}>Se connecter</button>
              </div>
            </div>

            <img src={logo} alt="Centraide QCA Logo" />
          </form>
        </div>

        <div className="right-block">
          <img src={logoWhite} alt="Centraide QCA Logo" />
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = state => {
  return {
    error: state.user.loginError,
    disabledError: state.user.disabledError,
    user: state.user.infos,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loginUser: (email, password) =>
      dispatch(userActions.login(email, password)),
  };
};

LoginPage.propTypes = {
  loginUser: PropTypes.func,
  error: PropTypes.bool,
  disabledError: PropTypes.bool,
  user: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
